export default __webpack_public_path__ + "static/cabbage-7b9381e8cf3f74af5b321bd560a46bcd.png";